import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOptAlt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconOptAlt"><Path fillRule="evenodd" clipRule="evenodd" d="M15.4197 4H21V6H16.5803L8.58032 20H3V18H7.41968L15.4197 4ZM15 18H21V20H15V18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOptAlt;
